import {ConditionType} from "../../../../model2/conditions/condition-types"
import Filter from "../filter"

export default function filters_changeFilterCondition(filter: Filter, type:ConditionType, value: any) {
    filter.type         = type
    filter.value        = value

    switch (type) {
        case ConditionType.BOOLEAN_EQUALS           :
            if (_.isNil(value)) {
                filter.value    = false
            }
            break

        case ConditionType.NOT_NULL                 :
        case ConditionType.IS_NULL                  :
            break

        case ConditionType.INCLUDES                 :
        case ConditionType.EXCLUDES                 :
        case ConditionType.ARRAY_INTERSECTION       :
        case ConditionType.NUMBER_GREATER_THAN      :
        case ConditionType.NUMBER_LESS_THAN         :
        case ConditionType.NUMBER_EQUALS            :
        case ConditionType.STRING_EQUALS            :
        case ConditionType.STRING_CONTAINS          :
            if (!_.isNil(value)) {
                filter.value    = value
            }
            break

        case ConditionType.NUMBER_BETWEEN           :
            if (!_.isNil(value?.greaterThan) && !_.isNil(value?.lessThan)) {
                filter.value    = value
            }
            break

        case ConditionType.DATE_FIXED_RANGE         :
            if (_.isNil(value)) {
                filter.value    = {start: moment(), end: moment().add(1, 'month')}
            }
            break

        case ConditionType.DATE_FIXED_BEFORE        :
        case ConditionType.DATE_FIXED_AFTER         :
        case ConditionType.DATE_FIXED_EQUALS        :
            if (_.isNil(value)) {
                filter.value    = moment()
            }
            break

        case ConditionType.DATE_RELATIVE_RANGE      :
            if (_.isNil(value)) {
                filter.value    = {start: 0, end: 30}
            }
            break

        case ConditionType.DATE_RELATIVE_PERIOD     :
            if (_.isNil(value)) {
                filter.value    = {relativity: 'filter', period: 'week'}
            }
            break

        case ConditionType.DATE_RELATIVE_AFTER      :
        case ConditionType.DATE_RELATIVE_BEFORE     :
        case ConditionType.DATE_RELATIVE_EQUALS     :
            if (_.isNil(value)) {
                filter.value    = 0
            }
    }
}